import * as React from "react"
import styled from "styled-components"

const SearchWrap = styled.section`
  height: 0;
  width: calc(100vw - 60px);
  margin: 0 30px;
  position: fixed;
  top: 66px;
  left: 0;
  background: #fff;
  box-shadow: 0 -6px 10px 5px rgba(0,0,0,0.5);
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  overflow-y: scroll;
  transition: all 600ms;

  &[aria-hidden="false"] {
    height: calc(100vh - 96px);
    visibility: visible;
    z-index: 2;
    opacity: 1;
  }

  @media (prefers-reduced-motion) {
    transition: opacity 600ms;
  }
`;

const Search = styled.iframe`
  width: 100%;
  height: 100%;
`

const CloseButton = styled.button`
{
  width: 30px;
  height: 30px;
  z-index: 5;
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 1.0875rem;
  position: absolute;
  top: 40px;
  right: 0;


  span {
    position: absolute;
    top: 15px;
    left: 0;
    height: 2px;
    width: 100%;
    background: #fff;
  }
  span:first-of-type {
    transform: rotate(45deg);
  }

  span:last-of-type {
    transform: rotate(-45deg);
  }
`

let searchListenerTriggered = false;


const focusLock = () => {
  if ( searchListenerTriggered ) {
    return;
  }

  searchListenerTriggered = true;

  document.addEventListener('keyup', e => {
    let isEscape = false;

    if ("key" in e) {
        isEscape = (e.key === "Escape" || e.key === "Esc");
    } else {
        isEscape = (e.keyCode === 27);
    }

    if (! isEscape) {
        return;
    }

    const searchContainer = document.getElementById('search-container');

    if ( 'true' === searchContainer.getAttribute('aria-hidden') ) {
      return;
    }

    document.getElementById('search-toggle').click();
  });

  document.addEventListener('keyup', (e) => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if ( !isTabPressed ) {
      return;
    }

    const searchContainer = document.getElementById('search-container');

    if ( 'true' === searchContainer.getAttribute('aria-hidden') ) {
      return;
    }

    const  focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = searchContainer.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent      = searchContainer.querySelectorAll(focusableElements);
    const lastFocusableElement  = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  })
}

const SearchFooter = () => (
    <SearchWrap id="search-container" aria-hidden="true" >
        <CloseButton 
        aria-label="close search"
        aria-controls="search-container"
        onClick={() =>{ document.getElementById( 'search-toggle' ).click(); }}
        >
        <span></span>
        <span></span>
        </CloseButton>
        <Search src="" loading="lazy" title="Search Dr. Adam Scheiner" onLoad={focusLock} />
    </SearchWrap>
)

export default SearchFooter
